import React, { Fragment, useRef, useState } from "react"
import PropTypes from "prop-types"
import {
    useTable,
    useGlobalFilter,
    useAsyncDebounce,
    useExpanded,
    usePagination,
} from "react-table"
import { Table, Row, Col, Button, FormGroup, Input } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import JobListGlobalFilter from "../../components/Common/GlobalSearchFilter"
import { useEffect } from "react"
import Flatpickr from "react-flatpickr";

// Define a default UI for filtering
function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
    isJobListGlobalFilter,
}) {
    const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined)
    }, 200)

    return (
        <React.Fragment>
            <Col md={12}>
                <div className="search-box w-full d-inline-block">
                    <div className="position-relative">
                        <label htmlFor="search-bar-0" className="search-label">
                            <span id="search-bar-0-label" className="sr-only">
                                Search this table
                            </span>
                            <input
                                onChange={e => {
                                    setValue(e.target.value)
                                    onChange(e.target.value)
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control"
                                placeholder={"Search…"}
                                value={value || ""}
                            />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                    </div>
                </div>
            </Col>
            {isJobListGlobalFilter && <JobListGlobalFilter />}
        </React.Fragment>
    )
}

const SendMessageTable = ({
    columns,
    data,
    className,
    pagePerSize,
    isLoading,
    handleSendMessage,
    TotalRecords,
    setDateFilter, dateFilter,
    setdateDisble, dateDisble,
    userFilter, setUserFilter, users,
}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        gotoPage,
        setPageSize,
        state,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data,
            defaultColumn: { Filter: DefaultColumnFilter },
            initialState: {
                pageIndex: 0,
                pageSize: 3000,
                sortBy: [
                    {
                        desc: true,
                    },
                ],
            },
        },
        useGlobalFilter,
        useExpanded,
        usePagination
    )
    const handlesort = column => {
    }
    const [pageIndex, setpageIndex] = useState(1)
    const [prevValue, setPrevValue] = useState();
    const [RoleId, setRoleId] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).RoleId)
    )

    const generateSortingIndicator = column => {
        return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
    }

    const onChangeInSelect = event => {
        setPageSize(Number(event.target.value))
    }


    const onChangeInInput = event => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0
        gotoPage(page)
    }


    if (pagePerSize) {
        useEffect(() => {
            pagePerSize(pageSize)
        }, [pageSize, state.globalFilter])
    }


    const handleClick = () => {
        setdateDisble(!dateDisble);
    }
    const checkbox = useRef();
    const flatpickrRef = useRef(null);


    return (
        <Fragment>
            <Row>

                <Col md={3} className="" >
                    <FormGroup className="mb-2">
                        <div className="d-flex" >
                            <div className="form-control " onClick={() => handleClick()} style={{ width: "40px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                <input
                                    id="checkbox"
                                    type="checkbox"
                                    style={{ width: "15px", height: "15px", cursor: "pointer" }}
                                    checked={dateDisble}
                                    onChange={e => setdateDisble(e.target.checked)}
                                    ref={checkbox}
                                />
                            </div>
                            <Flatpickr
                                ref={flatpickrRef}
                                disabled={!dateDisble}
                                className="form-control d-block"
                                placeholder="dd M,yyyy"
                                options={{
                                    mode: "range",
                                    dateFormat: "d-m-Y"
                                }}
                                value={dateFilter}
                                onChange={(e) => { setDateFilter(e) }}

                            />
                            <i
                                className="fas fa-calendar-alt calander-icon"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    flatpickrRef.current.flatpickr.open();
                                }}
                            ></i>
                        </div>
                    </FormGroup>
                </Col>

                {RoleId == 1 &&
                    <>
                        <Col md="2" className="table-header" >
                            <Input
                                type="select"
                                id="validationCustom01"
                                className="form-control"
                                name="user"
                                // onChange={validation.handleChange}
                                onChange={e => {
                                    setUserFilter(e.target.value)
                                }}
                                value={userFilter}
                            >
                                <option value={0}>Select Send by</option>
                                {users.map((item, index) => {
                                    return (
                                        <option key={index} value={item.Key}>
                                            {item.Value}
                                        </option>
                                    )
                                })}
                            </Input>
                        </Col>

                        <Col md={7} style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                            <FormGroup className="mb-2">
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn "
                                    onClick={handleSendMessage}
                                >
                                   Create SOP
                                </Button>
                            </FormGroup>
                        </Col>
                    </>

                }
            </Row>


            <div className="table-responsive react-table">
                <Table bordered hover {...getTableProps()} className={className}>
                    <thead className="table-light table-nowrap">
                        {headerGroups.map(headerGroup => (
                            <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        key={column.id}
                                        onClick={() => {
                                            handlesort(column)
                                        }}
                                        className={` ${(RoleId != 1 && column.Header == 'Action' ? 'column-display' : "")} `}
                                        {...column.getHeaderProps({
                                            style: {
                                                minWidth: column.minWidth,
                                                maxWidth: column.maxWidth,
                                                width: column.width,
                                            },
                                        })}
                                    >
                                        <div className={`mb-0`}>
                                            {column.render("Header")}
                                            {generateSortingIndicator(column)}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    {page.length ? (
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row)
                                return (
                                    <Fragment key={row.getRowProps().key}>
                                        <tr>
                                            {row.cells.map(cell => {
                                                return (
                                                    <td
                                                        key={cell.id}
                                                        className={`text-nowrap ${RoleId != 1 && (cell.column.Header == 'Action' ? 'column-display' : "")} `}
                                                        // className={`text-nowrap`}
                                                        {...cell.getCellProps({
                                                            style: {
                                                                minWidth: cell.minWidth,
                                                                maxWidth: cell.maxWidth,
                                                                width: cell.width,
                                                            },
                                                        })}
                                                    >
                                                        {cell.render("Cell")}
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                    </Fragment>
                                )
                            })}
                        </tbody>
                    ) : (
                        <tbody
                            style={{
                                textAlign: "center",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "40px",
                            }}
                        >
                            <tr>
                                <td colSpan={headerGroups[0].headers.length}>
                                    {isLoading ? ("Loading...") : ("No Record Found")}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </Table>
            </div>

            {/* <Row className="justify-content-md-end justify-content-center align-items-center">
                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            color="primary"
                            onClick={() => setpageIndex(pageIndex - 1)}
                            disabled={pageIndex == 1}
                        >
                            {"<<"}
                        </Button>
                    </div>
                </Col>
                <Col className="col-md-auto d-none d-md-block">
                    Page
                    <strong style={{ marginLeft: "5px" }}>
                        {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
                    </strong> | Total <strong>{TotalRecords}</strong>
                </Col>
                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            color="primary"
                            onClick={() => setpageIndex(pageIndex + 1)}
                            disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
                        >
                            {">>"}
                        </Button>
                    </div>
                </Col>
            </Row> */}

        </Fragment>
    )
}

SendMessageTable.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default SendMessageTable